<template>
	<div class="subList" v-loading="loading">
		<!-- <el-scrollbar class="data-subList" > -->
		<data-list
			:data="subData"
			:table-style="{ name: 'mixture' }"
			v-bind="$attrs"
			v-on="$listeners"
		></data-list>
		<!-- </el-scrollbar> -->
	</div>
</template>
<script>
export default {
	props: ['tableData', 'scope'],
	data() {
		return {
			subData: [],
			loading: false,
		};
	},
	methods: {
		async getData() {
			this.loading = true;
			let data = await this.tableData.getSubData(this.scope.row);
			this.subData = data;
			this.loading = false;
		},
	},
	mounted() {
		this.getData();
	},
};
</script>
<style lang="scss" scoped>
.subList {
	margin: 5px 20px 20px 20px;
	min-height: 60px;
	max-height: 400px;
	height: auto;
	// height:400px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #d8d8d8;
		border-radius: 6px;
	}

	&::-webkit-scrollbar-track {
		background-color: #fff;
		border-radius: 4px;
	}
}
.data-subList {
	// 	改变滚动条样式

	//  height: 100%;
	// overflow-x: hidden;
}
</style>
